// Accounting's words (pages/ux-full screens/accounting.js and components/money.js): a list filter's
// choices and a month's name. What drew here is a DataTable (rows/money-columns.ts) and Domain/Money's
// CloseChecklist now, and the list's filter is a Segmented (BL-189).

/** One choice of a list's filter (a Segmented): its key and its word. */
export type FilterChoice<K extends string> = readonly [K, string];

const MONTH = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];
/** 2026-09-01 → September 2026 */
export const monthWords = (d: string): string => `${MONTH[Number(d.slice(5, 7)) - 1]} ${d.slice(0, 4)}`;
